import { useEffect, useState } from "react";
import {
  desaplicarImputaciones,
  getImputacionesByRecibo,
} from "../service/getImputacionesByRecibo";

export const useDesaplicarImputaciones = ({
  open,
  idRecibo,
  showToast,
  getDocuments,
}) => {
  const [data, setData] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    try {
      const res = await getImputacionesByRecibo(idRecibo);
      setData(res);
    } catch {
      showToast("Error al cargar imputaciones", "error");
    }
  };

  useEffect(() => {
    if (open) {
      fetchData();
      setSelectedIds([]);
    }
  }, [open]);

  const toggle = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };

  const submit = async () => {
    if (selectedIds.length === 0) {
      showToast("Seleccioná al menos una", "warning");
      return;
    }

    setLoading(true);

    try {
      await desaplicarImputaciones({
        idRecibo,
        ids: selectedIds,
        user: "frontend",
      });

      showToast("Desaplicado correctamente", "success");
      await fetchData();
      getDocuments();
      setSelectedIds([]);
    } catch {
      showToast("Error al desaplicar", "error");
    } finally {
      setLoading(false);
    }
  };

  return {
    data,
    selectedIds,
    loading,
    toggle,
    submit,
  };
};
